import { useFormik } from 'formik';
import { creatorbase } from '@round/api';
import { useReport, useUpdateReportMutation } from '@round/creatorbase-helpers/api-hooks';
import { ProjectSelectTableRow } from './ProjectSelectTable/helpers';
import { useInitialProjects } from './useInitialProjects';
import useReportId from '../hooks/useReportId';

type FormValues = {
    projects: ProjectSelectTableRow[];
};

type Params = {
    onSubmitSuccess: (report: creatorbase.Report) => void;
    onSubmitError: (error: Error) => void;
    isFormActive: boolean;
};

export function useProjectSelectForm({ onSubmitSuccess, onSubmitError, isFormActive }: Params) {
    const reportId = useReportId();
    const { data: reportData } = useReport(reportId);
    const { update: updateReport } = useUpdateReportMutation(reportId);

    const {
        data: initialProjects,
        isLoading,
        isError,
    } = useInitialProjects({
        projectIds: reportData?.project_ids ?? [],
        enabled: isFormActive && !!reportData,
    });

    const formik = useFormik<FormValues>({
        initialValues: {
            projects: initialProjects,
        },
        onSubmit: async (values, helpers) => {
            if (!reportId) {
                return;
            }

            try {
                helpers.setSubmitting(true);

                const report = await updateReport({
                    id: reportId,
                    project_ids: values.projects.map((p) => p.id) ?? [],
                });

                onSubmitSuccess(report);
            } catch (e) {
                if (e instanceof Error) {
                    onSubmitError(e);
                }
            }
        },
        enableReinitialize: true,
    });

    return {
        formik,
        isLoading,
        isError,
    };
}
